var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43011 2.22412C5.66834 2.22412 6.67212 5.2115 6.67212 8.89662H4.43011C3.34962 8.89662 2.80938 8.89662 2.47495 8.52357C2.14053 8.15051 2.19875 7.65924 2.31518 6.67669C2.62256 4.08289 3.4534 2.22412 4.43011 2.22412Z",
    stroke: "#2E1834",
    strokeWidth: 1.66812
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67212 8.95696V20.7356C6.67212 22.4167 6.67212 23.2573 7.18585 23.5882C8.02539 24.1289 9.32327 22.995 9.97598 22.5833C10.5153 22.2432 10.785 22.0731 11.0843 22.0633C11.4077 22.0527 11.6821 22.2158 12.2649 22.5833L14.39 23.9235C14.9632 24.285 15.2499 24.4658 15.5688 24.4658C15.8877 24.4658 16.1744 24.285 16.7476 23.9235L18.8726 22.5833C19.412 22.2432 19.6817 22.0731 19.9809 22.0633C20.3044 22.0527 20.5788 22.2158 21.1616 22.5833C21.8143 22.995 23.1122 24.1289 23.9517 23.5882C24.4655 23.2573 24.4655 22.4167 24.4655 20.7356V8.95696C24.4655 5.78307 24.4655 4.19612 23.4883 3.21012C22.5111 2.22412 20.9384 2.22412 17.793 2.22412H4.44796",
    stroke: "#2E1834",
    strokeWidth: 1.66812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5688 8.89675C14.3404 8.89675 13.3446 9.6436 13.3446 10.5649C13.3446 11.4862 14.3404 12.233 15.5688 12.233C16.7972 12.233 17.793 12.9798 17.793 13.9011C17.793 14.8224 16.7972 15.5693 15.5688 15.5693M15.5688 8.89675C16.5372 8.89675 17.3611 9.36094 17.6664 10.0088M15.5688 8.89675V7.78467M15.5688 15.5693C14.6004 15.5693 13.7765 15.1051 13.4712 14.4572M15.5688 15.5693V16.6813",
    stroke: "#2E1834",
    strokeWidth: 1.66812,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.e3d74caeb1cc5d4da2f986ec03ff7b8d.svg";
export { ForwardRef as ReactComponent };